module.exports = __webpack_public_path__ + "img/logo-empresta.11ec1ed4.svg";